import * as React from "react";

const SvgLibraryFilled = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 21 20"
    fill="none"
  >
    <g clip-path="url(#clip0_13050_1863)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 1.89429C3.5 1.342 3.94772 0.894287 4.5 0.894287H9.34198C9.74131 0.894287 10.1024 1.13187 10.2604 1.49861L10.9072 3H15.5C16.6046 3 17.5 3.89543 17.5 5V15C17.5 16.1046 16.6046 17 15.5 17H5.5C4.39543 17 3.5 16.1046 3.5 15V5C3.5 4.97387 3.5005 4.94786 3.50149 4.92197H3.5V1.89429ZM1.25 4C0.835786 4 0.5 4.33579 0.5 4.75V15.25C0.5 15.6642 0.835786 16 1.25 16C1.66421 16 2 15.6642 2 15.25V4.75C2 4.33579 1.66421 4 1.25 4ZM19.75 4C19.3358 4 19 4.33579 19 4.75V15.25C19 15.6642 19.3358 16 19.75 16C20.1642 16 20.5 15.6642 20.5 15.25V4.75C20.5 4.33579 20.1642 4 19.75 4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.55697 13.3787C9.22854 13.6341 8.75 13.4001 8.75 12.984V8.02867C8.75 7.61259 9.22854 7.37855 9.55697 7.63399L12.7426 10.1117C12.9999 10.3119 12.9999 10.7008 12.7426 10.901L9.55697 13.3787Z"
        fill="#333333"
      />
    </g>
    <defs>
      <clipPath id="clip0_13050_1863">
        <rect
          width="1em"
          height="1em"
          fill="currentColor"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SvgLibraryFilled;
